export default __webpack_public_path__ + "static/media/Automation_Leadspaces_FINAL_RPA.f3f99b17.svg";